/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import {
  Col,
  Form,
  Modal,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
} from 'react-bootstrap';
import ErrorSet from 'lorautils/errors/ErrorSet';
import Select from 'loracoms/Select';
import InlineSelect from 'loracoms/InlineSelect';
import ControlTips from 'loracoms/ControlTips';
import IntlMsg from 'lorautils/intl/IntlMsg';
import callAPI from '@/api/callAPI';
import { parseContent } from '../util';
import styles from '../styles.scss';

const kInitalState = {
  submitted: false,
  type: 8,
  id: '',
  mac2: '',
  status: '',
  remark: '',
  penalty: null,
  errors: ErrorSet.createEmpty()
    .add('FE_EMPTY', 'id'),
};

const propTypes = {
  intl: intlShape.isRequired,
  show: PropTypes.bool.isRequired,
  onAdded: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  network: PropTypes.string.isRequired,
  typesJSON: PropTypes.object.isRequired,
  deleteNode: PropTypes.object.isRequired,
};

class CreateModal extends React.Component {
  constructor(props) {
    super(props);
    const { types } = parseContent(props.typesJSON);
    this.state = {
      ...kInitalState,
      show: props.show,
      network: props.network,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.gateway.create');
    this.types = types;
    this.deleteNode = props.deleteNode;
    this.onHide = this.onHide.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeType = this.onChangeType.bind(this);
    this.typeOptions = [
      { label: this.intlMsg.msg('8channels'), value: 8 },
      { label: this.intlMsg.msg('16channels'), value: 16 },
    ];
  }

  componentWillMount() {
    this.loadGateways();
  }

  componentWillReceiveProps({ show, network, deleteNode, typesJSON }) {
    if (show !== this.props.show) {
      this.setState({ show });
    }
    if (network !== this.props.network) {
      this.setState({ network });
    }
    if (!_.isEqual(deleteNode, this.deleteNode)) {
      this.deleteNode = deleteNode;
      this.tdmGateways = _.filter(this.tdmGateways, t => t.id !== deleteNode.id);
      this.compareGateways();
    }
    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      const { types } = parseContent(typesJSON);
      this.types = types;
    }
  }

  loadGateways() { // eslint-disable-line
    const p1 = callAPI({ endpoint: '/lora/gateways?q=&mark=&sort=-lastOn&limit=1000' });
    const p2 = callAPI({ endpoint: '/tdmng/gateways?mark=&limit=1000' });
    Promise.all([p1, p2]).then(([res1, res2]) => {
      this.gateways = res1.list;
      this.tdmGateways = res2.list;
      this.compareGateways();
    }).catch(() => {});
  }

  compareGateways() {
    const disableds = [];
    _.forEach(this.tdmGateways, (t) => {
      disableds.push({ id: t.id });
      if (t.mac2) {
        disableds.push({ id: t.mac2 });
      }
    });
    this.availableList = _.xorBy(disableds, this.gateways, 'id');
    const gatewayOpts = _.map(this.availableList, a => ({ label: a.name, value: a.id }));
    this.setState({ gatewayOpts });
  }

  onChangeType(xs) {
    const { errors } = this.state;
    this.setState({ type: xs[0] });
    if (xs[0] === 16) {
      this.setState({ mac2: '', errors: errors.add('FE_EMPTY', 'mac2') });
    }
  }

  onChangeSelect(s, key) {
    let { errors } = this.state;
    errors = errors.remove(key);

    this.setState({ [key]: s, errors }, () => {
      const { mac2, id } = this.state;
      if (mac2 && mac2 === id) {
        errors = errors.add('FE_GW_MUST_DIFFEFRENT', 'id').add('FE_GW_MUST_DIFFEFRENT', 'mac2');
        this.setState({ errors });
      } else {
        errors = errors.remove('id').remove('mac2');
        this.setState({ errors });
      }
    });
  }

  onChangeIpt(e, key) {
    const p = _.trim(e.target.value);
    let { errors } = this.state;
    if (p === '' || (_.isInteger(_.toNumber(p)) &&
      _.toNumber(p) >= 0 && _.toNumber(p) <= 255)) {
      errors = errors.remove(key);
    } else {
      errors = errors.add('FE_EMPTY', key);
    }
    this.setState({ [key]: p, errors });
  }

  onHide() {
    this.props.onHide();
    this.setState({ ...kInitalState });
  }

  onSubmit() {
    let { errors } = this.state;
    errors = errors.remove('submit');
    this.setState({ submitted: true });
    if (!errors.isEmpty()) return;

    const { type, id, mac2, network, remark, penalty } = this.state;
    const config = _.find(this.types.networktypes, n => n.networks && n.networks.name === network);
    if (!config) return;

    const memo = { remark: _.trimEnd(remark) };
    const gw1 = _.find(this.gateways, g => g.id === id);
    const gw2 = _.find(this.gateways, g => g.id === mac2);
    if (gw1) {
      memo.name1 = gw1.name;
    }
    if (gw2) {
      memo.name2 = gw2.name;
    }

    let body = { id, mac2, memo: JSON.stringify(memo) };
    const channelKey = String(type);
    let rxch = 4;
    if (!_.isNil(config.rxch)) {
      rxch = config.rxch[channelKey];
    }
    const bchannels = config.bchannels[channelKey];
    const rx2ch = bchannels[_.random(0, bchannels.length - 1)];


    const channel = config.tchannels.parameters;
    const xoffs = (config.tchannels.xoffs || {})[channelKey] || [];
    const tchannels = _.map(config.tchannels.channels[channelKey], (id1, idx) => ({
      ...channel, id: id1, xoff: xoffs[idx],
    }));

    const pair = config.pairs.parameters;
    const pairs = _.map(config.pairs.channels[channelKey], id2 => ({
      ...pair,
      pairs: (config.pairs.pairs || {})[channelKey],
      src: { ...pair.src, channel: id2 },
      dst: { ...pair.dst, channel: id2 },
    }));

    body = { ...body, rxch, bchannels, rx2ch, tchannels, pairs };
    body.penalty = _.toNumber(penalty) || 0;

    callAPI({
      body: { ...body },
      method: 'POST',
      endpoint: '/tdmng/gateways',
    }).then(() => {
      this.onHide();
      this.props.onAdded();
      this.resetGateways(body);
    }).catch((err) => {
      this.setState({ errors: errors.add(err.code, 'submit') });
    });
  }

  resetGateways(gw) {
    this.tdmGateways.push(gw);
    this.compareGateways();
  }

  render() {
    const {
      id,
      mac2,
      show,
      type,
      status,
      errors,
      remark,
      penalty,
      submitted,
      gatewayOpts = [],
    } = this.state;

    return (
      <Modal
        bsClass="aisz-modal-light"
        backdrop="static"
        show={show}
        onHide={this.onHide}
      >
        <Modal.Header closeButton>
          {this.intlMsg.msg('header')}
        </Modal.Header>
        <Modal.Body>
          <Form horizontal onSubmit={this.handleSubmit}>
            <FormGroup>
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('type')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <InlineSelect
                  options={this.typeOptions}
                  onChange={this.onChangeType}
                  values={[type]}
                />
              </Col>
            </FormGroup>
            <FormGroup validationState={submitted && errors.has('id') ? 'error' : undefined}>
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('id')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <Select
                  value={id}
                  options={gatewayOpts}
                  onChange={s => this.onChangeSelect(s, 'id')}
                />
                <ControlTips
                  message={this.intlMsg.errorMsg(errors.get('id'))}
                  show={submitted && errors.has('id')}
                  azStyle="danger"
                />
              </Col>
            </FormGroup>
            {type === 16 &&
              <FormGroup validationState={submitted && errors.has('mac2') ? 'error' : undefined}>
                <Col md={3}>
                  <ControlLabel bsClass="aisz-control-label">
                    {this.intlMsg.msg('mac2')}
                  </ControlLabel>
                </Col>
                <Col md={6}>
                  <Select
                    value={mac2}
                    options={gatewayOpts}
                    onChange={s => this.onChangeSelect(s, 'mac2')}
                  />
                  <ControlTips
                    message={this.intlMsg.errorMsg(errors.get('mac2'))}
                    show={submitted && errors.has('mac2')}
                    azStyle="danger"
                  />
                </Col>
              </FormGroup>
            }
            <FormGroup>
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('penalty')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  value={penalty}
                  placeholder="0~255"
                  bsClass="aisz-form-control-f"
                  onChange={e => this.onChangeIpt(e, 'penalty')}
                />
                <ControlTips
                  message={'0~255'}
                  show={submitted && errors.has('penalty')}
                  azStyle="danger"
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('remark')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  value={remark}
                  bsClass="aisz-form-control-f"
                  onChange={e => this.setState({ remark: _.trimStart(e.target.value) })}
                />
              </Col>
            </FormGroup>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {errors.has('submit') &&
          <span className={styles.error}>
            <i className="fa fa-exclamation-triangle" aria-hidden="true" />&nbsp;
            {this.intlMsg.errorMsg(errors.get('submit'))}
          </span>
          }
          <Button
            bsStyle="aisz-default"
            onClick={this.onHide}
            className={styles.white}
          >
            {this.intlMsg.msg('cancel')}
          </Button>
          <Button
            bsStyle="aisz-success"
            onClick={this.onSubmit}
            disabled={status === 'pending'}
          >
            {status === 'pending' && <i className="fa fa-spin fa-spinner m-r-s" />}
            {this.intlMsg.msg('confirm')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

CreateModal.propTypes = propTypes;

const mapStateToProps = state => ({
  typesJSON: state.tdm.setting,
});

export default connect(mapStateToProps)(injectIntl(CreateModal));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Gateway/CreateModal.jsx